import { z } from 'zod';
import { baseDocSchema, objectIdSchema } from './common.js';

export const creditsLedgerTypeSchema = z.enum([
  'purchase',
  'consume',
  'refund',
  'free_monthly',
  'referral',
  'adjustment',
]);
export type CreditsLedgerType = z.infer<typeof creditsLedgerTypeSchema>;

export const creditsLedgerEntrySchema = baseDocSchema.extend({
  orgId: objectIdSchema,
  type: creditsLedgerTypeSchema,
  amount: z.number().int(),
  balanceAfter: z.number().int().nonnegative(),
  refType: z.enum(['order', 'qr', 'stripe_charge', 'system']).optional(),
  refId: z.string().optional(),
  stripeChargeId: z.string().optional(),
  notes: z.string().max(500).optional(),
});
export type CreditsLedgerEntry = z.infer<typeof creditsLedgerEntrySchema>;

/**
 * Tabla de precios de créditos en USD. Definida del lado del backend
 * pero visible aquí para que el frontend muestre la grilla de pricing.
 */
export const CREDIT_PACKAGES = [
  { id: 'starter', credits: 100, totalUsdCents: 2200, perUnitCents: 22 },
  { id: 'growth', credits: 300, totalUsdCents: 5400, perUnitCents: 18 },
  { id: 'scale', credits: 1_000, totalUsdCents: 14_000, perUnitCents: 14 },
  { id: 'pro', credits: 5_000, totalUsdCents: 55_000, perUnitCents: 11 },
  { id: 'enterprise', credits: 20_000, totalUsdCents: 160_000, perUnitCents: 8 },
] as const;

export type CreditPackageId = (typeof CREDIT_PACKAGES)[number]['id'];

export const creditPackageSchema = z.object({
  packageId: z.enum(CREDIT_PACKAGES.map((p) => p.id) as [CreditPackageId, ...CreditPackageId[]]),
});
